import PersonItem from './PersonItem';

export default PersonItem;
